import i18next from 'i18next';
import { percent } from '../helpers';
import { type FlexflowChartData } from './types';

export const flexflowChartData = (theme: any) => (data: FlexflowChartData) => ({
  title: `${i18next.t('historical use', { ns: 'overview' })}: ${i18next.t('flexible compensation', { ns: 'common' })}`,
  data: [
    {
      id: 'countEmployeesAskedForflexflowCard',
      legend: i18next.t('have asked for a card', { ns: 'overview' }),
      color: [theme.palette.colorPalette[1], theme.palette.colorPalette[2]],
      value: !data?.disabled ? 0 : percent(data?.employeesThatRequestedCard, data?.eligibleEmployees) || 0,
      explanation:
        "only employees with 'Active' or 'Leave' status and with a gross monthly salary of €1,356 or more can access Flexflow"
    },
    {
      id: 'flexflowCardUsage',
      legend: i18next.t('of those who have asked for a card, have used it', { ns: 'overview' }),
      color: [theme.palette.colorPalette[1], theme.palette.colorPalette[2]],
      value: !data?.disabled ? 0 : percent(data?.employeesThatUsedCard, data?.employeesThatRequestedCard) || 0
    }
  ]
});
